import { useEffect, useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button, Typography } from "@mui/material";
// import noCampaignImage from "../../src/Images/cuate.svg";
import noCampaignImage from "../../src/Images/ImageToStl.com_cuate.avif";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import Loader from "../Loader";
import { Tooltip } from "@mui/material";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";

const campaignHeadCells = [
  {
    id: "name",
    label: "Goal Name",
  },
  {
    id: "calories",
    label: "No. of  leads",
  },
  {
    id: "fat",
    label: "Date of creation",
  },
  {
    id: "carbs",
    label: "Action",
  },
];

const GoalDetails = () => {
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [campaignGoalsData, setCampaignGoalsData] = useState([]);
  const [campaignTitle, setCampaignTitle] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();
  const location = useLocation();
  const [filterGoals, setFilterGoals] = useState("");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOnchange = (event) => {
    setFilterGoals(event.target.value);
  };

  const filteredCampaignGoals = useMemo(() => {
    if (!filterGoals) {
      return campaignGoalsData;
    }
    return campaignGoalsData.filter((goal) =>
      goal.GoalName.toLowerCase().includes(filterGoals.toLowerCase())
    );
  }, [campaignGoalsData, filterGoals]);

  useEffect(() => {
    if (location.pathname.length > 6) {
      setIsLoading(true);
      axios
        .get(
          `${
            BaseUrl.baseurl
          }/email-marketing/automation/get-campaign-goals-details/${
            userDetails && userDetails.details._id
          }/${location.pathname.slice(7, location.pathname.length)}`,
          {
            headers: {
              Authorization: `Bearear ${userDetails && userDetails.token}`,
            },
          }
        )
        .then((response) => {
          if (response.data.status) {
            setIsLoading(false);
            setCampaignTitle(response.data?.details?.Campaign?.Name);
            setCampaignGoalsData(response.data?.details?.Details);
          } else {
            setIsLoading(false);
            setCampaignTitle("");
            setCampaignGoalsData([]);
            if (response.data.tokenExpire) {
              localStorage.removeItem("MailSenderuserDetails");
              window.location.reload();
            }
          }
        })
        .catch((err) => console.log("Error"));
    }
  }, [location.pathname.slice(7, location.pathname.length)]);

  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - campaignGoalsData.length)
      : 0;

  function formatDateString(inputString) {
    if (location.pathname?.length > 6) {
      const options = {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      };
      const date = new Date(inputString);
      const formattedDate = date.toLocaleDateString("en-US", options);
      return `${formattedDate}`;
    }
  }
  return (
    <div
      style={{
        height: "100%",
        overflow: "auto",
      }}
    >
      <Box sx={{ width: "100%" }}>
        <Paper
          sx={{
            width: "100%",
            borderRadius: "6px",
            border: "1px solid #DDD",
            boxShadow: "none",
          }}
        >
          <div
            style={{
              borderBottom: "1px solid #DDD",
              padding: "6px 16px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            {campaignTitle !== null && (
              <Button
                disableRipple
                disableElevation
                sx={{
                  cursor: "default",
                  outline: "none !important",
                  borderBottom: "2px solid #1C485F",
                  borderRadius: 0,
                  color: "#1C485F",
                  textTransform: "none",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
              >
                <svg
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    history.push("/Goals");
                  }}
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.57 5.92969L3.5 11.9997L9.57 18.0697"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M20.5019 12H3.67188"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <Typography
                  style={{
                    color: "#1C485F",
                    fontSize: "15px",
                    fontWeight: 700,
                    fontFamily: "Source Sans 3",
                  }}
                  component="h2"
                >
                  {campaignTitle}
                </Typography>
              </Button>
            )}

            <div
              style={{
                marginLeft: "auto",
                display: "flex",
                alignItems: "center",
                gap: "4px",
                backgroundColor: "#FAFAFA",
                padding: "8px 12px",
                borderRadius: "4px",
                border: "1px solid #1c485f",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M7.66536 13.9987C11.1632 13.9987 13.9987 11.1632 13.9987 7.66536C13.9987 4.16756 11.1632 1.33203 7.66536 1.33203C4.16756 1.33203 1.33203 4.16756 1.33203 7.66536C1.33203 11.1632 4.16756 13.9987 7.66536 13.9987Z"
                  stroke="#868686"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14.6654 14.6654L13.332 13.332"
                  stroke="#868686"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <input
                value={filterGoals}
                onChange={handleOnchange}
                type="text"
                style={{
                  outline: "none",
                  backgroundColor: "transparent",
                  padding: "0px 12px",
                }}
                placeholder="Search.."
              />
            </div>
          </div>
          {/* <GoalContacts /> */}
          <TableContainer>
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size={"medium"}
            >
              {isLoading ? (
                // display loading body here...
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={campaignHeadCells.length}
                      align="center"
                      sx={{ borderBottom: "0px" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "8px",
                          padding: "130px 0px",
                        }}
                      >
                        <Loader />
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : filteredCampaignGoals.length > 0 ? (
                <>
                  <TableHead>
                    <TableRow
                      sx={{ backgroundColor: "#FAFAFA", borderRadius: "4px" }}
                    >
                      {campaignHeadCells.map((headCell) => (
                        <TableCell key={headCell.id} align="left">
                          <Typography
                            variant="subtitle1"
                            fontWeight="bold"
                            fontSize={"13px"}
                          >
                            {headCell.label}
                          </Typography>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  {/* // data display body here... */}
                  <TableBody>
                    {filteredCampaignGoals
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => (
                        <TableRow
                          sx={{
                            backgroundColor:
                              index % 2 !== 0 ? "#FAFAFA" : "#FFF",
                          }}
                        >
                          <TableCell align="left">
                            <p
                              style={{
                                marginTop: "0px",
                                fontFamily: "Source Sans 3",
                                fontSize: "15px",
                                fontStyle: "normal",
                                fontWeight: 700,
                                color: "#1C485F",
                              }}
                            >
                              {row.GoalName}
                            </p>
                          </TableCell>
                          <TableCell align="left">{row.LeadCount}</TableCell>
                          <TableCell align="left">
                            {formatDateString(row.CreatedDate)}
                          </TableCell>
                          <TableCell align="left">
                            <button
                              onClick={() =>
                                history.push(`/Goal/leads/${row.GoalId}`)
                              }
                              style={{
                                fontSize: "12px",
                                color: "#868686",
                                fontWeight: 400,
                                fontFamily: "Source Sans 3",
                                fontStyle: "normal",
                                outline: "none",
                                padding: "6px 10px",
                                border: "1px solid #868686",
                                borderRadius: "4px",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <Tooltip title="Open leads list" arrow style={{ display: "flex",
                                alignItems: "center",
                                gap: "4px",}}>
                                  
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 21 20"
                                fill="none"
                              >
                                <path
                                  d="M13.3846 9.99896C13.3846 11.649 12.0513 12.9823 10.4013 12.9823C8.7513 12.9823 7.41797 11.649 7.41797 9.99896C7.41797 8.34896 8.7513 7.01562 10.4013 7.01562C12.0513 7.01562 13.3846 8.34896 13.3846 9.99896Z"
                                  stroke="#868686"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M10.4003 16.8932C13.3419 16.8932 16.0836 15.1599 17.9919 12.1599C18.7419 10.9849 18.7419 9.0099 17.9919 7.8349C16.0836 4.8349 13.3419 3.10156 10.4003 3.10156C7.45859 3.10156 4.71693 4.8349 2.80859 7.8349C2.05859 9.0099 2.05859 10.9849 2.80859 12.1599C4.71693 15.1599 7.45859 16.8932 10.4003 16.8932Z"
                                  stroke="#868686"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              View
                                    </Tooltip>
                            </button>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </>
              ) : (
                // empty view body nothing found content here...
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={campaignHeadCells.length}
                      align="center"
                      sx={{ borderBottom: "0px" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <img
                          src={noCampaignImage}
                          alt="Nothing found"
                          style={{ height: "250px" }}
                          loading="lazy"
                        />
                        <p
                          style={{
                            fontFamily: "Source Sans 3",
                            fontSize: "20px",
                            fontStyle: "normal",
                            fontWeight: 700,
                            color: "#393939",
                          }}
                        >
                          No data found
                        </p>
                        <p
                          style={{
                            fontFamily: "Source Sans 3",
                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            color: "#868686",
                            marginTop: "0px",
                          }}
                        >
                          {filterGoals.length === 0
                            ? `Oops! You don’t have any goals yet!`
                            : `There's no goal that fits your search`}
                        </p>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: 53 * emptyRows,
                  }}
                >
                  <TableCell colSpan={campaignHeadCells.length} />
                </TableRow>
              )}
            </Table>
          </TableContainer>
          {isLoading
            ? null
            : campaignGoalsData.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={campaignGoalsData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </div>
              )}
        </Paper>
      </Box>
    </div>
  );
};

export default GoalDetails;
